import { z } from "zod";
import dayjs from "dayjs";
export const zDayjsSchema = z.preprocess((val) => {
    if (typeof val === "string" || val instanceof Date) {
        return dayjs(val);
    }
    return val;
}, z.custom((val) => dayjs.isDayjs(val), {
    message: "Must be a valid dayjs date",
}));
